<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-07 22:29:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/SkuColor/index.vue
-->
<template>
  <!--选择组件  -->
  <div class="con border_bottom1px_shadow clearfix" @click="showSku">
    <div class="left font12 font_weight400 colo055 color_select">选择</div>
    <div class="left font12 font_weight400 colo087 color_select">
      <span>{{ selectSkuString || "请选择规格" }}</span>
      <!-- <span>请选择规格</span> -->
    </div>
    <img
      src="@/assets/common/icon_back_b87_24@2x.png"
      alt=""
      class="right color_right"
    />
  </div>
</template>
<script>
export default {
  props: {
    selectSkuString: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    showSku() {
      this.$emit("showSku");
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  padding: 13px 0 10px;
  .color_select {
    line-height: 17px;
    margin: 4px 20px 0 0;
  }
  .color_right {
    width: 24px;
  }
}
</style>
